// extracted by mini-css-extract-plugin
export var searchHeader = "_66-0";
export var searchHeaderDark = "_66-1";